import { initAccordion }     from '../modules/Components/accordion.js';
import { initTabbedContent } from '../modules/Components/tabbed-content.js';

function init() {
  initAccordion();
  initTabbedContent();
  initDpoForm();
  initDpoAction();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function initDpoAction() {
  if (new URLSearchParams(window.location.search).get('action') !== 'contatodpo') return;

  const target = document.querySelector('.form-dpo');
  if (!target) return;

  requestAnimationFrame(() => {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const offset = 11.1 * rootFontSize;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);

    window.scrollTo({ top, behavior: 'smooth' });
  });
}

// ── DPO Form ──────────────────────────────────────────────────────────────────
function initDpoForm() {
  const form = document.querySelector('.form-dpo__form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearDpoErrors(form);

    const errors = validateDpoForm(form);
    if (errors.length > 0) {
      errors.forEach(({ field, message }) => showDpoFieldError(field, message));
      errors[0].field.focus();
      return;
    }

    const btnText  = form.querySelector('.form-dpo__btn-text');
    const btnArrow = form.querySelector('.form-dpo__btn-arrow');
    const originalText = btnText ? btnText.textContent : '';

    if (btnText)  { btnText.disabled  = true; btnText.textContent = 'Enviando...'; }
    if (btnArrow) { btnArrow.disabled = true; }

    if (!window.rbDpoAjax?.url) {
      showDpoFeedback(form, 'Configuração de envio indisponível.', 'error');
      if (btnText)  { btnText.disabled  = false; btnText.textContent = originalText; }
      if (btnArrow) { btnArrow.disabled = false; }
      return;
    }

    const data = new FormData(form);
    data.set('action', 'rb_dpo_form_submit');

    try {
      const response = await fetch(window.rbDpoAjax.url, {
        method: 'POST',
        body: data,
      });

      if (!response.ok) throw new Error('network');

      const json = await response.json();

      if (json.success) {
        showDpoFeedback(form, json.data.message, 'success');
        form.reset();
      } else {
        const msg = json.data?.message || 'Ocorreu um erro. Tente novamente.';
        showDpoFeedback(form, msg, 'error');
      }
    } catch (err) {
      console.error('DPO form error:', err);
      showDpoFeedback(form, 'Ocorreu um erro de conexão. Tente novamente.', 'error');
    } finally {
      if (btnText)  { btnText.disabled  = false; btnText.textContent = originalText; }
      if (btnArrow) { btnArrow.disabled = false; }
    }
  });
}

function validateDpoForm(form) {
  const errors = [];

  const rules = [
    { name: 'assunto',  type: 'select', message: 'Por favor, selecione uma opção.' },
    { name: 'mensagem', type: 'text',   message: 'Por favor, escreva sua mensagem.' },
  ];

  rules.forEach(({ name, type, message }) => {
    const field = form.querySelector(`[name="${name}"]`);
    if (!field) return;

    let invalid = false;
    if (type === 'text')   invalid = field.value.trim() === '';
    if (type === 'select') invalid = field.value === '';

    if (invalid) errors.push({ field, message });
  });

  return errors;
}

function showDpoFieldError(field, message) {
  const container = field.closest('.form-dpo__field');
  if (!container) return;
  container.classList.add('form-dpo__field--error');
  const span = document.createElement('span');
  span.className = 'form-dpo__error-msg';
  span.textContent = message;
  container.appendChild(span);
}

function clearDpoErrors(form) {
  form.querySelectorAll('.form-dpo__field--error').forEach((el) => {
    el.classList.remove('form-dpo__field--error');
  });
  form.querySelectorAll('.form-dpo__error-msg').forEach((el) => el.remove());

  const feedback = form.querySelector('.form-dpo__feedback');
  if (feedback) {
    feedback.className = 'form-dpo__feedback';
    feedback.textContent = '';
  }
}

function showDpoFeedback(form, message, type) {
  const feedback = form.querySelector('.form-dpo__feedback');
  if (!feedback) return;
  feedback.className = `form-dpo__feedback form-dpo__feedback--${type}`;
  feedback.textContent = message;
  feedback.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
